import Vue from 'vue'
import Router from 'vue-router'
import goodsdetail from '@/components/goodsdetail'
import instruction from '@/components/instruction'
import app from '@/components/app'
import Retail from '@/pages/retail/index'
import Search from '@/pages/retail/search'
import Category from '@/pages/retail/category'
import Goods from '@/pages/retail/goods'
Vue.use(Router)
export default new Router({
    history: true,
    linkActiveClass: 'active',
    linkExactActiveClass: 'active',
    routes: [{
            path: '/',
            redirect: '/app',
            component: app,
            name: '美书'
        },
        {
            path: '/app',
            name: 'app',
            component: app
        },
        {
            name: '目录',
            path: '/detaillist/detail/goodsdetail/:id',
            component: goodsdetail
        },
        {
            path: '/detaillist/detail/goodsdetail/instruction/:id',
            component: instruction
        },
        {
            name: 'retail',
            path: '/retail/index',
            component: Retail
        },
        {
            name: 'retail-search',
            path: '/retail/search',
            component: Search
        },
        {
            name: 'retail-category',
            path: '/retail/category',
            component: Category
        },
        {
            name: 'retail-goods',
            path: '/retail/goods',
            component: Goods
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js